import Swal from "sweetalert2";
import 'js-loading-overlay';

(function ($) {
    class App {
        fav_event_key = 'lkc_ev_favs';
        fav_member_key = 'lkc_mb_favs';

        constructor() {
            this.memberFavourite();
            this.eventFavourite();
            this.myFavouritesLoop();
            this.removeFavoriteEventButton();
            this.removeFavoriteMemberButton();
            this.myFavoriteButton();
            this.showPassword();
            this.registerAction();
            this.loginAction();
            this.checkUpcomingEvents();
            this.showEmailPopupClicked();
        }

        utf8ToBase64(str) {
            return window.btoa(unescape(encodeURIComponent(str)));
        }

        base64ToUtf8(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        /**
         * Save local storage
         * @param key
         * @param value
         */
        saveLSData(key, value) {
            localStorage.setItem(key, value)
        }

        /**
         * Get local storage data.
         *
         * @param key
         */
        getLSData(key) {
            return localStorage.getItem(key)
        }

        /**
         * Remove loacl storage data.
         *
         * @param key
         */
        removeLSData(key) {
            localStorage.removeItem(key);
        }

        cleanFavouriteEvents() {
            this.removeLSData(this.fav_event_key);
        }

        cleanFavouriteMembers() {
            this.removeLSData(this.fav_member_key);
        }

        checkUpcomingEvents() {
            $(document).ready((e) => {
                let columnWrapper = $('#upcoming_events');
                if (!columnWrapper.length) {
                    let outerElement = $('#upcoming_events_label');
                    outerElement.append('<p>No events found</p>');
                }
            })
        }

        /**
         * Get current favourite events.
         * @returns string|string[]
         */
        getFavouriteEvents(convertArr = true) {
            let locStorages = this.getLSData(this.fav_event_key);

            if (locStorages && convertArr) {
                locStorages = JSON.parse(locStorages);
                return [...new Set(locStorages)]
            }
            return locStorages;
        }

        /**
         * Save localstorage.
         * @param ids
         */
        addFavouriteEvents(ids) {
            this.saveLSData(this.fav_event_key, JSON.stringify(ids))
        }

        getFavouriteMembers() {
            return this.getLSData(this.fav_member_key)
        }

        removeFavouriteEvent(eventId) {
            let favouriteEvents = this.getFavouriteEvents();
            if (Array.isArray(favouriteEvents)) {
                for (let i = 0; i < favouriteEvents.length; i++) {
                    if (favouriteEvents[i] == eventId) {
                        favouriteEvents.splice(i, 1);
                    }
                }
                // Clean replace the value of the favourite events.
                this.cleanFavouriteEvents();
                // Re-save the favourite events.
                this.addFavouriteEvents(favouriteEvents);
            }
        }

        removeFavouriteMember(memberEncodedString) {
            let currentFavouriteMembers = this.getFavouriteMembers();
            if (null != currentFavouriteMembers) {
                currentFavouriteMembers = JSON.parse(currentFavouriteMembers);
            }
            if (Array.isArray(currentFavouriteMembers)) {
                for (let i = 0; i < currentFavouriteMembers.length; i++) {
                    if (currentFavouriteMembers[i] == memberEncodedString) {
                        currentFavouriteMembers.splice(i, 1);
                    }
                }
                // Clean replace the value of the favourite events.
                this.cleanFavouriteMembers();
                // Re-save the favourite events.
                this.saveLSData(this.fav_member_key, JSON.stringify(currentFavouriteMembers))
            }
        }

        /**
         * Save favourite members to localstorage.
         * @param objMembers
         */
        addFavouriteMembers(objMembers) {
            let currentFavourites = this.getFavouriteMembers();
            let memberObjArr = [];
            if (null == currentFavourites) {
                memberObjArr.push(objMembers);
            } else {
                memberObjArr = JSON.parse(currentFavourites)
                memberObjArr.push(objMembers)
            }
            this.saveLSData(this.fav_member_key, JSON.stringify(memberObjArr))
        }

        updateFavouriteEventCounter(plus = true) {
            const liElm = $('ul.social_bookmarks > li.social_bookmarks_favorites'),
                spanElm = liElm.find('a span');
            liElm.addClass('updated');
            let currentValue = parseInt(spanElm.text());
            if (plus) {
                currentValue++;
            } else {
                currentValue--;
            }
            spanElm.text(currentValue > 9 ? '9+' : currentValue);
            setTimeout((e) => {
                liElm.removeClass('updated');
            }, 500)
        }

        memberFavourite() {
            $('body').on('click', 'a.tribe-events-event-action-favourite-member', (e => {
                e.preventDefault();
                let aElm = e.target;
                if ('a' != aElm.localName) {
                    aElm = $(aElm).closest('a');
                }
                // Make sure that the button is not clicked multiple times.
                if ($(aElm).hasClass('marked')) {
                    return false;
                }
                $(aElm).addClass('marked');
                const objMemberStrEnc = $(aElm).attr('data-member');
                const objMemberStr = this.base64ToUtf8(objMemberStrEnc);
                if (lkc_obj.is_login) {
                    $.ajax({
                        url: lkc_obj.ajax_url,
                        data: {
                            action: lkc_obj.prefix + 'favourite_member',
                            member: objMemberStr,
                        },
                        type: 'post',
                        dataType: 'json',
                        success: (data) => {
                            if (!data.success) {
                            }
                        },
                        error: (data) => {

                        }
                    })
                } else {
                    this.addFavouriteMembers(objMemberStrEnc)
                }

                // Update the counter.
                this.updateFavouriteEventCounter();
            }))
        }

        eventFavourite() {
            const btnFavourite = $('a.tribe-events-event-action-favourite');

            btnFavourite.click((e) => {
                const targetElm = $(e.target).closest('.tribe-events-event-action-favourite'),
                    dataEvent = targetElm.data('event'),
                    dataNonce = targetElm.data('nonce'),
                    dataIsLogged = 1 == targetElm.data('logged');
                // Make sure that the button is not clicked multiple times.
                if (targetElm.hasClass('marked')) {
                    return false;
                }
                targetElm.addClass('marked');
                // Update the favourite event counter.
                this.updateFavouriteEventCounter();
                e.preventDefault();
                if (dataIsLogged) {
                    $.ajax({
                        url: lkc_obj.ajax_url + '?action=' + lkc_obj.prefix + 'favourite&nonce=' + dataNonce + '&event=' + dataEvent,
                        type: 'get',
                        success: (data) => {
                            if (!data.success) {
                            }
                        },
                        error: (data) => {

                        }
                    })
                } else {
                    if (typeof (Storage) !== "undefined") {
                        // Get current favourite events.
                        let currentFavs = this.getFavouriteEvents();
                        // Merge the favourite events with a new one.
                        if (Array.isArray(currentFavs)) {
                            currentFavs.push(dataEvent);
                        } else {
                            currentFavs = [dataEvent];
                        }
                        // Update the favourite events.
                        this.addFavouriteEvents(currentFavs);
                    } else {
                        alert("Please use a modern browser")
                    }
                }
            })
        }

        addFavouriteRemoveButton() {
            const favouriteEventsWrapper = $('#events-favourites'),
                eventsWrapper = favouriteEventsWrapper.find('.tribe-events-loop-wrapper'),
                eventThumbnails = eventsWrapper.find('.type-tribe_events');

            // Maybe loop all events.
            if (eventThumbnails.length) {
                $.each(eventThumbnails, (i, event) => {
                    const eventId = $(event).find('.tribe-events-event-action-favourite').attr('data-event'),
                        eventRemoveButton = "<button class='remove-favorite' data-id='" + eventId + "'><i class='ri-close-circle-line'></i></button>";
                    $(event).find('.tribe-events-photo-event-wrap').append(eventRemoveButton)
                })
            }
        }

        showEmailPopupClicked() {
            const showPopupButton = $('#btn-show-email-popup'),
                redirectUrl = showPopupButton.data('redirect');
            showPopupButton.click((e) => {
                this.showEmailPopUp(redirectUrl);
            })
        }

        async showEmailPopUp(redirectUrl) {
            let eventsIds = this.getFavouriteEvents(),
                favMembers = this.getFavouriteMembers(),
                membersArr = [];
            if (null !== favMembers) {
                membersArr = JSON.parse(favMembers);
            }

            // If the user doesn't have any favorites, we'll display false popup.
            if (null === favMembers && null === eventsIds) {
                Swal.fire({
                    title: 'Empty Favorites',
                    text: 'Please add events and or business to your favorites first.',
                    icon: 'warning',
                    confirmButtonColor: '#015071'
                })
                return;
            }

            const {value: email} = await Swal.fire({
                icon: 'warning',
                title: 'Options to Save Your Favorites:',
                html: "Option 1:<br/>Enter your email address, click send and we’ll email them to you.<br/><br/>Option 2:<br/>Create an account to save your favorites and access them anytime.",
                input: 'email',
                // inputLabel: 'Your email address',
                inputPlaceholder: 'Enter your email address',
                footer: '<a href="' + redirectUrl + '">Create an Account</a>',
                showCancelButton: true,
                confirmButtonText: 'Send',
                confirmButtonColor: '#015071'
            })
            if (email) {
                JsLoadingOverlay.show({
                    spinnerIcon: 'ball-clip-rotate-multiple',
                    spinnerColor: '#eb9500',
                });
                $.ajax({
                    url: lkc_obj.ajax_url,
                    data: {
                        action: lkc_obj.prefix + 'send_favs',
                        email: email,
                        events: eventsIds,
                        members: membersArr
                    },
                    type: 'post',
                    dataType: 'json',
                    success: (data) => {
                        JsLoadingOverlay.hide();
                        if (data.success) {
                            Swal.fire({
                                title: 'Success!',
                                text: 'Email has been sent',
                                icon: 'success',
                                confirmButtonColor: '#015071'
                            })

                            // Clean all data.
                            this.cleanFavouriteEvents();
                            this.cleanFavouriteMembers();

                            // Clean the html markup.
                            $('.tribe-events-loop-wrapper').html('');
                            $('.accessally-user-directory-user-list-container').html('');
                            // Prevent the popup from visible again.
                            // this.saveLSData('fav_viewed', 1);
                        }
                    }
                });
            }
        }

        myFavouritesLoop() {
            const convertTagTextIntoSpan = (text) => {
                let result = '';
                if (text) {
                    let textArr = text.split(' ');
                    let isMultiple = textArr.length > 1;
                    $.each(textArr, (index, txt) => {
                        let txtLength = txt.length;
                        let fontSize = isMultiple ? 'font-size: 12px' : '';
                        if (txtLength > 10) {
                            fontSize = 'font-size: 8px';
                        } else if (txtLength > 7) {
                            fontSize = 'font-size: 10px';
                        } else if (txtLength > 5) {
                            fontSize = 'font-size: 12px';
                        }
                        result += "<span style='" + fontSize + "'>" + txt + "</span>";
                    })
                }
                return result;
            }

            const favouriteEventsWrapper = $('#events-favourites');
            if (favouriteEventsWrapper.length) {
                const eventWrapper = favouriteEventsWrapper.find('.tribe-events-loop-wrapper'),
                    memberWrapper = favouriteEventsWrapper.find('.tribe-members-loop-wrapper > .accessally-user-directory-user-list-container');


                let descElm = $('.accessally-user-directory-description-item-2 .accessally-inline-field-update-display');
                descElm.on('click', 'a.btn-view-desc', (e) => {
                    e.preventDefault();
                    $(e.target).closest('.accessally-user-directory-description-item-2 .accessally-inline-field-update-display').addClass('opened');
                })

                descElm.on('click', 'a.btn-close-desc', (e) => {
                    e.preventDefault();
                    $(e.target).closest('.accessally-user-directory-description-item-2 .accessally-inline-field-update-display').removeClass('opened');
                })

                if (1 != lkc_obj.is_login) {

                    let eventsIds = this.getFavouriteEvents(),
                        favMembers = this.getFavouriteMembers(),
                        membersArr = [];

                    // Load the members.
                    if (null !== favMembers) {
                        membersArr = JSON.parse(favMembers);
                        $.each(membersArr, (index, memberEnc) => {
                            let memberStr = atob(memberEnc);
                            let member = JSON.parse(memberStr);
                            const isFeatured = '1' == member.featured ? "<div class='accessally-user-directory-user-featured'>FEATURED MEMBER</div>" : "<div class='accessally-user-directory-user-featured'></div>";
                            let tagTxt = member.tag ? convertTagTextIntoSpan(member.tag) : '';
                            const memberWeb = member.website ? '<div class="tribe-events-event-web"><a href="' + member.website + '" target="_blank"><i class="ri-global-line"></i> Visit Website</a></div>' : '';
                            let memberClass = 'accessally-user-directory-user-entry accessally-user-directory-user-entry-image-left accessally-user-directory-vertical-margin';
                            const fixedDesc = decodeURIComponent(escape(member.description));
                            if ('1' == member.featured) {
                                memberClass += ' featured';
                            }
                            memberWrapper.append(
                                "<div class='" + memberClass + "'>" +
                                "   " + isFeatured + "\n" +
                                "   <div class='member-tag'>" + tagTxt + "</div>\n" +
                                "   <div class='accessally-user-directory-user-profile-image accessally-user-directory-user-profile-image-left '>\n" +
                                "       <button class='remove-favorite-member' data-member='" + memberEnc + "'><i class='ri-close-circle-line'></i></button>\n" +
                                "       " + member.thumbnail + memberWeb + "\n" +
                                "   </div>\n" +
                                "   <div class='accessally-user-directory-user-profile-description' style='margin-left:200px;'>\n" +
                                "       <div class='accessally-user-directory-description-item accessally-user-directory-description-item-0'></div>\n" +
                                "       <div class='member-tag-name'>" + member.tag + "</div>\n" +
                                "       <div class='accessally-user-directory-description-item accessally-user-directory-description-item-1'><div class='accessally-inline-field-update-display accessally-inline-field-update-display-iden' accessally-inline-field-display='16---43b426d416'>" + member.title + "</div></div>\n" +
                                "       <div class='accessally-user-directory-description-item accessally-user-directory-description-item-2'><div class='accessally-inline-field-update-display accessally-inline-field-update-display-iden' accessally-inline-field-display='18---5a64236738'><a href='#' class='btn-close-desc'><i class='ri-close-circle-line'></i></a><p>" + fixedDesc + "</p></div></div>\n" +
                                "       <div class='accessally-user-directory-description-item accessally-user-directory-description-item-3'><div class='accessally-inline-field-update-display accessally-inline-field-update-display-iden' accessally-inline-field-display='20---900accd9b1'>(509) 682-2251</div></div>\n" +
                                "       <div class='accessally-user-directory-description-item accessally-user-directory-description-item-4'><div class='accessally-inline-field-update-display accessally-inline-field-update-display-iden' accessally-inline-field-display='22---278f16e541'>518 W Manson Hwy Chelan, WA 98816</div></div>\n" +
                                "       <div class='accessally-user-directory-description-item accessally-user-directory-description-item-5'><a class='accessally-inline-field-update-display accessally-inline-field-update-display-iden' accessally-inline-field-link='28---6543254a18' target='_blank' href='http://www.chelanlanes.com' rel='noopener'>http://www.chelanlanes.com</a></div>\n" +
                                "       <div class='accessally-user-directory-description-item accessally-user-directory-description-item-6'><div class='accessally-inline-field-update-display accessally-inline-field-update-display-iden' accessally-inline-field-display='30---c542c8756b'>chelanlanes@outlook.com</div></div>\n" +
                                "       <div class='accessally-user-directory-action-row'>\n" +
                                "           <ul>\n" +
                                "               <li><a class='tribe-events-event-action-favourite-member marked' href='#' data-member='#'><i class='ri-heart-line'></i></a></li>\n" +
                                "           </ul>\n" +
                                "       </div>\n" +
                                "       <div class='tribe-events-list-photo-roller'>\n" +
                                "           <button><i class='ri-arrow-up-line'></i></button>\n" +
                                "       </div>\n" +
                                "   </div>\n" +
                                "   <div class='accessally-user-directory-clear'></div>\n" +
                                "</div>");
                        })

                        // let descElm = $('.accessally-user-directory-description-item-2 .accessally-inline-field-update-display');
                        // descElm.on('click', 'a.btn-view-desc', (e) => {
                        //     e.preventDefault();
                        //     $(e.target).closest('.accessally-user-directory-description-item-2 .accessally-inline-field-update-display').addClass('opened');
                        // })

                        // descElm.on('click', 'a.btn-close-desc', (e) => {
                        //     e.preventDefault();
                        //     $(e.target).closest('.accessally-user-directory-description-item-2 .accessally-inline-field-update-display').removeClass('opened');
                        // })
                    }

                    // Load the events.
                    if (null !== eventsIds) {
                        $.ajax({
                            url: lkc_obj.ajax_url + '?action=' + lkc_obj.prefix + 'events&event=' + eventsIds,
                            type: 'get',
                            success: (data) => {
                                if (data.success) {
                                    $.each(data.data, (index, event) => {
                                        eventWrapper.append(event)
                                    })
                                } else {
                                    $.each(data.data, (index, notif) => {
                                        eventWrapper.append('<p>' + notif + '</p>')
                                    })
                                }

                                // Trigger for adding remove favorite button.
                                this.addFavouriteRemoveButton();
                            },
                            error: (data) => {

                            }
                        })
                    }

                    // Save favorites.
                    // const isViewed = null !== this.getLSData('fav_viewed');
                    // if (!isViewed && (null !== favMembers || null !== eventsIds)) {
                    //     // window.addEventListener('mouseout', async (e) => {
                    //     //     let from = e.relatedTarget || e.toElement;
                    //     //     if ((!from || from.nodeName == "HTML") && e.clientY <= 100) {
                    //     //         if (!isShown) {
                    //     //             isShown = true;
                    //     //             this.showEmailPopUp(redirectUrl);
                    //     //         }
                    //     //     }
                    //     // }, false)
                    // }

                } else {
                    $(document).ready(e => {
                        // Trigger for adding remove favorite button.
                        this.addFavouriteRemoveButton();
                    })
                }
            }
        }

        removeFavoriteEventButton() {
            $('body').on('click', 'button.remove-favorite', (e) => {
                e.preventDefault();
                let buttonElm = $(e.target);
                // If the button is clicked true i element.
                if ('i' == e.target.localName) {
                    buttonElm = $(e.target).closest('button.remove-favorite');
                }
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#ff7733',
                    // cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, remove!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        const eventId = buttonElm.attr('data-id');
                        if (1 == lkc_obj.is_login) {
                            $.ajax({
                                url: lkc_obj.ajax_url + '?action=' + lkc_obj.prefix + 'remove_favourite_event&event=' + eventId,
                                type: 'get',
                                success: (data) => {

                                },
                                error: (data) => {

                                }
                            })
                        } else {
                            this.removeFavouriteEvent(eventId);
                        }

                        // Now, remove the thumbnail.
                        $(buttonElm).closest('.type-tribe_events').remove();

                        // Trigger counter.
                        this.updateFavouriteEventCounter(false);

                        // Then show the alert.
                        Swal.fire(
                            'Deleted!',
                            'Your event has been deleted.',
                            'success'
                        )
                    }
                })
            })
        }

        removeFavoriteMemberButton() {
            $('body').on('click', 'button.remove-favorite-member', (e) => {
                e.preventDefault();
                let buttonElm = $(e.target);
                // If the button is clicked true i element.
                if ('i' == e.target.localName) {
                    buttonElm = $(e.target).closest('button.remove-favorite-member');
                }
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#ff7733',
                    // cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, remove!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        const memberEnc = buttonElm.attr('data-member');
                        const memberStr = atob(memberEnc);
                        if (1 == lkc_obj.is_login) {
                            $.ajax({
                                url: lkc_obj.ajax_url,
                                data: {
                                    action: lkc_obj.prefix + 'remove_favourite_member',
                                    member: memberStr
                                },
                                type: 'post',
                                dataType: 'json',
                                success: (data) => {

                                },
                                error: (data) => {

                                }
                            })
                        } else {
                            this.removeFavouriteMember(memberEnc);
                        }

                        // Now, remove the thumbnail.
                        $(buttonElm).closest('.accessally-user-directory-user-entry.accessally-user-directory-user-entry-image-left.accessally-user-directory-vertical-margin').remove();

                        // Trigger counter.
                        this.updateFavouriteEventCounter(false);

                        // Then show the alert.
                        Swal.fire(
                            'Deleted!',
                            'Your event has been deleted.',
                            'success'
                        )
                    }
                })
            })
        }

        myFavoriteButton() {
            const liElm = $('ul.social_bookmarks > li.social_bookmarks_favorites'),
                spanElm = liElm.find('a span');
            if (liElm.length) {
                spanElm.text('0');
                if (1 == lkc_obj.is_login) {
                    // We'll get the fav from the ajax.
                    $.ajax({
                        url: lkc_obj.ajax_url + '?action=' + lkc_obj.prefix + 'count_favourites',
                        type: 'get',
                        dataType: 'json',
                        success: (data) => {
                            let numberOfFavs = parseInt(data.data);
                            if (numberOfFavs > 9) {
                                numberOfFavs = '9+';
                            }
                            spanElm.text(numberOfFavs);
                        }
                    })
                } else {
                    let numberOfFavs = 0,
                        numberOfFavsMembers = 0;
                    let favoriteEvents = this.getFavouriteEvents();
                    if (favoriteEvents) {
                        numberOfFavs = parseInt(favoriteEvents.length);
                    }
                    // We'll get the fav from local storage.
                    // Now, we need to count favourite members as well.
                    let favMembers = this.getFavouriteMembers();
                    if (null !== favMembers) {
                        let memberObjArr = JSON.parse(favMembers);
                        numberOfFavsMembers = memberObjArr.length;
                    }
                    // Calculate new favourite numbers.
                    numberOfFavs += numberOfFavsMembers;

                    if (numberOfFavs > 9) {
                        numberOfFavs = '9+';
                    }
                    spanElm.text(numberOfFavs);

                    // const isInFavourite = ()
                    if (numberOfFavs > 0) {
                        let eventThumbnailsWrapper = $('#tribe-events-content.tribe-events-list.tribe-events-photo .tribe-events-loop-wrapper');
                        if (eventThumbnailsWrapper.length) {
                            let eventThumbnails = eventThumbnailsWrapper.find('.type-tribe_events.tribe-events-photo-event');
                            $.each(eventThumbnails, (index, eventThumb) => {
                                let isInFavourite = false;
                                $.each(favoriteEvents, (i, eventId) => {
                                    if ($(eventThumb).hasClass('post-' + eventId)) {
                                        isInFavourite = true;
                                        return false;
                                    }
                                })
                                if (isInFavourite) {
                                    let theFavButton = $(eventThumb).find('.tribe-events-event-action-favourite');
                                    theFavButton.addClass('marked');
                                }
                            })
                        }
                    }
                }
            }
        }

        showPassword() {
            const regPassword = $('#reg-password'),
                regShow = $('#reg-show');
            regShow.change((e) => {
                const isChecked = e.target.checked;
                regPassword.attr('type', isChecked ? 'text' : 'password');
            })
        }

        registerAction() {
            const regForm = $('#tribe-events-account-register-form'),
                submitBtn = regForm.find('input[type=submit]'),
                btnText = submitBtn.val(),
                myEvents = this.getFavouriteEvents(false);
            regForm.submit((e) => {
                submitBtn.prop('disabled', true).val('Loading...');
                e.preventDefault();
                $.ajax({
                    url: lkc_obj.ajax_url,
                    data: {
                        action: lkc_obj.prefix + 'register',
                        name: $('#reg-name').val(),
                        email: $('#reg-email').val(),
                        password: $('#reg-password').val(),
                        events: myEvents,
                        nonce: $('#reg_nonce').val()
                    },
                    type: 'post',
                    dataType: 'json',
                    success: (data) => {
                        if (data.success) {
                            Swal.fire({
                                title: 'Success!',
                                text: 'Registration success',
                                icon: 'success',
                                confirmButtonColor: '#a5dc86'
                            })
                                .then((e) => {
                                    const ref = $('#reg-ref');
                                    if (ref.length) {
                                        location.href = ref.val();
                                    } else {
                                        location.reload();
                                    }
                                })
                        } else {
                            submitBtn.prop('disabled', false).val(btnText);
                            Swal.fire({
                                title: 'Error',
                                text: data.data[0],
                                icon: 'error',
                            })
                        }
                    }
                });
            })
        }

        loginAction() {
            const loginForm = $('#tribe-events-account-login-form'),
                submitBtn = loginForm.find('input[type=submit]'),
                btnText = submitBtn.val(),
                myEvents = this.getFavouriteEvents(false);
            loginForm.submit((e) => {
                submitBtn.prop('disabled', true).val('Loading...');
                e.preventDefault();
                $.ajax({
                    url: lkc_obj.ajax_url,
                    data: {
                        action: lkc_obj.prefix + 'login',
                        email: $('#log-email').val(),
                        password: $('#log-password').val(),
                        events: myEvents,
                        nonce: $('#log_nonce').val()
                    },
                    type: 'post',
                    dataType: 'json',
                    success: (data) => {
                        if (data.success) {
                            const ref = $('#log-ref');
                            if (ref.length) {
                                location.href = ref.val();
                            } else {
                                location.reload();
                            }
                        } else {
                            submitBtn.prop('disabled', false).val(btnText);
                            Swal.fire({
                                title: 'Error',
                                text: data.data[0],
                                icon: 'error',
                            })
                        }
                    }
                });
            })
        }
    }

    new App();
})(jQuery)
